import React from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { Avatar, Popover } from 'antd'
import { userLogOut } from '../../appRedux/actions/Auth'
import ProfieAvatar from '../../assets/images/Dakar-User-Profile.png'
// import ProfieAvatasdar from '../../assets/images/profilepic.jpeg'
import IntlMessages from '../../util/IntlMessages'
import SwitchUserDialog from './SwitchUserDialog'
import { useHistory } from 'react-router-dom'
import { postDataToApp } from '../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../constants/MobAppConstants'

const UserInfo = () => {
  const dispatch = useDispatch()
  const store = useStore()
  const history = useHistory()

  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getProfilePic, setProfilePic] = React.useState('') // change state
  const [getDialogOpen, setDialogOpen] = React.useState(false) // change state

  React.useEffect(() => {
    let mounted = true
    let userPic = localStorage.getItem('profileImage')

    if (mounted) {
      if (userPic && userPic != '') {
        setProfilePic(userPic)
      } else {
        setProfilePic(ProfieAvatar)
      }
    }

    return () => (mounted = false)
  }, [localStorage.getItem('profileImage')])

  function dialogClose () {
    setDialogOpen(false)
  }

  function handleSwitchUser () {
    setDialogOpen(true)
    // if (window.location.href.toLowerCase().includes('/sell')) {
    //   setDialogOpen(true)
    // } else {
    //   handleLocalStorage()
    //   // history.push("/loginstore?signupStore=" + storeName);
    //   // localStorage.setItem('switchRedirectURL', window.location.pathname);
    //   window.location.href = `/loginstore`
    // }
  }

  const userMenuOptions = (
    <ul className='gx-user-popover'>
      <li onClick={() => dispatch(userLogOut(store.getState()))}>
        <span>
          <IntlMessages id='topbar.logout' />
        </span>
      </li>
      {isOnline && (
        <li onClick={() => handleSwitchUser()}>
          <span>
            <IntlMessages id='topbar.switchuser' />
          </span>
        </li>
      )}
    </ul>
  )

  return (
    <>
      <SwitchUserDialog open={getDialogOpen} setClose={dialogClose} />
      <Popover
        overlayClassName='gx-popover-horizantal'
        placement='bottomRight'
        content={userMenuOptions}
        trigger='click'
      >
        <Avatar src={getProfilePic} className='gx-avatar gx-pointer' alt='' />
      </Popover>
    </>
  )
}

export default UserInfo
